<osn-cxb-multi-select
  [formControl]="contentTypeControl"
  [options]="contentTypeOption"
  filterPlaceholderLabel="Filter in content types..."
  placeholder="Filter in content types..."
  filterNoEntriesFoundLabel="No content type found"
></osn-cxb-multi-select>
